import React, { useEffect, useRef, useState } from "react";
import { Container, Row } from "react-bootstrap";
import About from "../About/About";
import { FaArrowDown } from "react-icons/fa";
import { useTranslation } from "react-i18next";
import Animations from "../../Animations";
import Contact from "./Contact";
import { Helmet } from "react-helmet-async";
import Seoimg from "../../Assets/ServiceImg/fpv.webp";
import { useLocation } from "react-router-dom";

function Home({ cookiesAccepted }) {
   const { t } = useTranslation();
   const [videoLoaded, setVideoLoaded] = useState(false);
   const videoRef = useRef(null);

   const location = useLocation();
   const selectedLanguage = location.pathname.startsWith("/en") ? "en" : "es";

   useEffect(() => {
      const videoElement = videoRef.current; // 🔹 Copiamos el valor actual del ref

      const handleLoadedData = () => {
         setVideoLoaded(true);
      };

      if (videoElement) {
         videoElement.addEventListener("loadeddata", handleLoadedData);
      }

      return () => {
         if (videoElement) {
            videoElement.removeEventListener("loadeddata", handleLoadedData);
         }
      };
   }, []);

   const handleScrollAbout = () => {
      const elemento = document.getElementById("about");
      if (elemento) {
         elemento.scrollIntoView({ behavior: "smooth" });
      }
   };
      const handleScrollContact = () => {
         const elemento = document.getElementById("contact");
         if (elemento) {
            elemento.scrollIntoView({ behavior: "smooth" });
         }
      };
   
   const seoTranslations = {
      es: {
         title: "Producción Audiovisual con Drones | Joan Company",
         description:
            "Vídeo y fotografía aérea profesional: grabación FPV, eventos y contenido para marcas. Piloto certificado, producción completa de principio a fin.",
         keywords:
            "producción audiovisual con drones en Mallorca, vídeo aéreo profesional, piloto drones FPV, grabación aérea Mallorca, fotografía aérea, contenido audiovisual marcas",
         canonical: "https://www.joancompany.es",
      },
      en: {
         title: "Audiovisual Production with Drones | Joan Company",
         description:
            "Professional aerial video and photography: FPV recording, events and content for brands. Certified pilot, complete production from start to finish.",
         keywords:
            "audiovisual production with drones in Mallorca, professional aerial video, FPV drone pilot, aerial recording Mallorca, aerial photography, brand audiovisual content",
         canonical: "https://www.joancompany.es/en",
      },
   }

   return (
      <section>
         <Helmet>
            <title key="title">
               {seoTranslations[selectedLanguage].title}
            </title>
            <meta
               key="description"
               name="description"
               content={seoTranslations[selectedLanguage].description}
            />
            <meta
               key="keywords"
               name="keywords"
               content={seoTranslations[selectedLanguage].keywords}
            />
            <link rel="canonical" href={seoTranslations[selectedLanguage].canonical} />
            <meta property="og:image" content={Seoimg} />
            <meta
               property="og:title"
               content={seoTranslations[selectedLanguage].title}
            />
            <meta
               property="og:description"
               content={seoTranslations[selectedLanguage].description}
            />
            <link rel="image_src" href={Seoimg} />
            <link rel="icon" href={Seoimg} />
            <link
               rel="alternate"
               href="https://www.joancompany.es/"
               hreflang="es"
            />
            <link
               rel="alternate"
               href="https://www.joancompany.es/en/"
               hreflang="en"
            />
            <html lang={selectedLanguage} />
         </Helmet>
         <Container fluid className="home-section" id="home">
            <Row className="home-content">
               <Row className="home-row">
                  <div className="video-background">
                     {!videoLoaded && (
                        // <img
                        //    src="/images/windsurf.webp"
                        //    alt="cover"
                        //    className="cover-loader"
                        //    title="Cover"
                        //    fetchpriority="high"
                        //    loading="eager"
                        // />
                        <picture>
                           {/* Versión para Móvil: Crea una copia de la imagen a 800px de ancho */}
                           <source
                              media="(max-width: 768px)"
                              srcSet="/images/windsurf-mobile.webp"
                           />
                           {/* Versión Desktop y Fallback */}
                           <img
                              src="/images/windsurf.webp"
                              alt="Producción audiovisual y vídeo aéreo en Mallorca"
                              className="cover-loader"
                              fetchpriority="high"
                              loading="eager"
                           />
                        </picture>
                     )}
                     {cookiesAccepted && (
                        <iframe
                           src="https://player.vimeo.com/video/1125860243?background=1&autoplay=1&muted=1&loop=1&dnt=1"
                           width="3840"
                           height="2160"
                           frameBorder="0"
                           allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share"
                           referrerPolicy="strict-origin-when-cross-origin"
                           title="youtube-player"
                           className="y-video"
                           loading="lazy"
                           onLoad={() => setVideoLoaded(true)}
                        ></iframe>
                     )}
                  </div>
                  <div className="home-header">
                     <div className="home-first">
                        <h1
                           style={{ paddingBottom: 15 }}
                           className="heading-top"
                        >
                           {t("slogan_title")}
                        </h1>
                        <h2 className="heading-name">{t("slogan")}</h2>
                        <h3 className="heading">{t("slogan_desc")}</h3>
                        <div className="home-buttons">
                           <div className="show-work">
                              <button onClick={handleScrollAbout}>
                                 <span className="show-work-text">
                                    {t("view_work")}
                                    <Animations animationType="shake-animation">
                                       <FaArrowDown
                                          style={{ marginLeft: "8px" }}
                                       />
                                    </Animations>
                                 </span>
                              </button>
                           </div>
                           <div className="show-contact">
                              <button onClick={handleScrollContact}>
                                 <span className="show-contact-text">
                                    {t("get_in_touch")}
                                 </span>
                              </button>
                           </div>
                        </div>
                     </div>
                  </div>
               </Row>
            </Row>
         </Container>
         <Container fluid className="home-about-section" id="about">
            <Row className="about-container">
               <About cookiesAccepted={cookiesAccepted} />
            </Row>
         </Container>
         <Contact className="home-contact" />
      </section>
   );
}

export default Home;